import { Helmet } from 'react-helmet';
import { Col, Row, Skeleton, Space } from 'antd';

import { useGetWorkerByIdQuery } from 'app/services/workers';
import Details from './components/Details';
import Logs from './components/Logs';
import Tabs from './components/Tabs';
import useUrlParameter from 'utils/useUrlParameter';

const View = () => {
  const id = useUrlParameter<number>('id');
  const { data: worker, isLoading } = useGetWorkerByIdQuery(id);

  if (isLoading || !worker) return <Skeleton active />;

  return (
    <>
      <Helmet title={`Kvalilog > ${worker.FullName}`} />
      <Space direction="vertical" size="middle" className='antd-space' style={{ display: 'flex' }}>
        <Row>
          <Col span={24}>
            <Details worker={worker} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Tabs worker={worker} />
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Logs worker={worker} />
          </Col>
        </Row>
      </Space>
    </>
  );
};

export default View;
